// SearchControls.jsx
import { useTranslation } from "react-i18next";
import style from "./SearchControls.module.css";
import ShortcutKey from "@/ui/shortcutKey/ShortcutKey";

function SearchControls() {
	const { t } = useTranslation();

	return (
		<div className={style.controls}>
			<ShortcutKey symbols={["up", "down"]} name={t("search:controls.navigate")} />
			<ShortcutKey symbols={["return"]} name={t("search:controls.select")} />
			<ShortcutKey symbols={["esc"]} name={t("common:actions.close")} />
		</div>
	);
}

export default SearchControls;
